module.exports = __webpack_public_path__ + "img/website-Builder-Homepage.8c43fba.png";